export default {
  path: '/shop-cart',
  meta: {
    title: '购物车',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/shop-cart`),
}



// WEBPACK FOOTER //
// ./src/views/shopCart/router.js